<div  class="shell">
    <nav class="navbar navbar-expand-lg navbar-light fixed-top navbar-custom border">
      <div class="container-fluid navbar-header">
        <a class="navbar-brand" href="#">
          <img [src]="resources.imgs.CM">
        </a>
        <div class="collapse navbar-collapse">
          <ul class="nav nav-pills" *ngIf="routedComponent">
            <li class="nav-item" [class.active]="routedComponent.constructor.name == 'RisServersStateComponent'">
              <a class="nav-link" routerLink="/shell/ris-servers-state" routerLinkActive="active">WIM Servers</a>
            </li>
            <li class="nav-item" [class.active]="routedComponent.constructor.name == 'RisClientsStateComponent'">
              <a class="nav-link" routerLink="/shell/ris-desktop-clients-state" routerLinkActive ="active">WIM Desktop Clients</a>
            </li>
            <li class="nav-item" [class.active]="routedComponent.constructor.name == 'RisWebClientsStateComponent'">
              <a class="nav-link" routerLink="/shell/ris-web-clients-state" routerLinkActive ="active">WIM Web Clients</a>
            </li>
            <li *ngIf="isPermit('PatientPortalComponent')" class="nav-item" [class.active]="routedComponent.constructor.name == 'PatientPortalComponent'">
              <a class="nav-link" routerLink="/shell/patient-portal" routerLinkActive ="active">Patient Assistant</a>
            </li>
            <li *ngIf="isPermit('PatientKioskComponent')" class="nav-item" [class.active]="routedComponent.constructor.name == 'PatientKioskComponent'">
              <a class="nav-link" routerLink="/shell/patient-kiosk" routerLinkActive ="active">Patient Kiosk</a>
            </li>
            <li *ngIf="isPermit('RisMonitoringScriptsResultsComponent')" class="nav-item" [class.active]="routedComponent.constructor.name == 'RisMonitoringScriptsResultsComponent'">
              <a class="nav-link" routerLink="/shell/ris-monitoring-scripts-results" routerLinkActive="active">Monitoring Dashboard</a>
            </li>
            <li *ngIf="isPermit('RisMonitoringScriptsComponent')" class="nav-item" [class.active]="routedComponent.constructor.name == 'RisMonitoringScriptsComponent'">
              <a class="nav-link" routerLink="/shell/ris-monitoring-scripts" routerLinkActive="active">Monitoring Configuration</a>
            </li>
            <li *ngIf="isPermit('LogManagerComponent')" class="nav-item" [class.active]="routedComponent.constructor.name == 'LogManagerComponent'">
              <a class="nav-link" routerLink="/shell/log-manager" routerLinkActive="active">Log Manager</a>
            </li>
            <li *ngIf="isPermit('UploadLogFilesComponent')" class="nav-item" [class.active]="routedComponent.constructor.name == 'UploadLogFilesComponent'">
              <a class="nav-link" routerLink="/shell/upload-log-files" routerLinkActive="active">Log Upload</a>
            </li>
          </ul>
        </div>
        <div style="padding-top: 13px;">
          <style>
            .k-i-refresh {
              color:white;
            }
          </style>
          <button kendoButton (click)="refresh()" [primary]="true" style="height:29px; background-color:#2eaa2e; border-color:#2eaa2e">
            <span class="k-icon k-i-refresh"></span></button>
          <kendo-dropdownbutton [data]="dropDownButtonItems" [popupSettings]="{popupClass : 'settings-menu'}" [icon]="'cog'"  (itemClick)="onSplitButtonItemClick($event)">{{currUserName}}</kendo-dropdownbutton>
        </div>
      </div>
    </nav>
    <router-outlet (activate)="routedComponent = $event"></router-outlet>
</div>
<em-about *ngIf="showAbout" (onClose)="showAbout=false"></em-about>
<em-change-password *ngIf="showChangePassword" [userName]="currUserName" [passwordMinLength]="passwordMinLength" [userPasswordPattern]="userPasswordPattern" (onClose)="showChangePassword=false"></em-change-password>
